export default __webpack_public_path__ + "static/media/correct.0051b788.png";